import React from 'react'
import PropTypes from 'prop-types'
import './FilterSquares.scss'

/**
 * filterOptions prop takes in an array of objects with the following fields.
 * label: Label to be displayed in square
 * onSelect: Function to execute
 */
const FilterSquares = ({
  filterOptions,
  onSelect,
  numSquaresPerRow,
  rectangleVersion
}) => {
  let filterSquaresClass = 'FilterSquares'
  if (rectangleVersion) filterSquaresClass += ' FilterSquares--rectangle'

  return (
    <div className={filterSquaresClass}>
      {filterOptions.map((option, idx) => (
        <div
          className='FilterSquares__item'
          key={idx}
          style={{ width: `${100.0 / numSquaresPerRow}%` }}
        >
          <div
            className={`FilterSquares__square ${
              option.active ? 'FilterSquares_square--active' : ''
            }`}
            onClick={e => {
              e.stopPropagation()
              onSelect({ option: option.obj || option.label })
            }}
          >
            <div className='FilterSquares__label'>
              <span>{option.label}</span>
            </div>
          </div>
          <div className='FilterSquares__squareDecorator'>
            {option.decorator}
          </div>
        </div>
      ))}
    </div>
  )
}

FilterSquares.defaultProps = {
  numSquaresPerRow: 4
}

FilterSquares.propTypes = {
  filterOptions: PropTypes.array,
  onSelect: PropTypes.func,
  numSquaresPerRow: PropTypes.number
}

export default FilterSquares
